import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_hadaMkPe61BE: {
	id: 'prd_hadaM2DEV2kPe61BE'
	ident: 'prd_hadaMkPe61BE'
	sku: 'simple_premium_1w_4_57_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_O6Voe2DEV2RDIHBcg'
			amount: 22
			amount_usd: 4.57
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 4.57
			discount: 17.43
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_AF1uF2DEV22ux7iE0'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_hadaMkPe61BE, SubscriptionProduct>
const prd_hadaMkPe61BE = { ident: 'prd_hadaMkPe61BE' } as typeof _prd_hadaMkPe61BE

export default prd_hadaMkPe61BE
